import { render } from "./yjyc.vue?vue&type=template&id=692cf8b7&scoped=true&ts=true"
import script from "./yjyc.vue?vue&type=script&lang=ts"
export * from "./yjyc.vue?vue&type=script&lang=ts"

import "./yjyc.vue?vue&type=style&index=0&id=692cf8b7&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692cf8b7"]])

export default __exports__